import React, { type FunctionComponent, useContext, useState } from 'react'

/**
 * What's the difference between Regular and Actual Hours?
 * "regular" hours refer to the business-as-usual store hours set for locations.
 * "actual" hours refer to the delivery hours as seen by logistics.
 *
 * Most often, regularStoreOpen === actualStoreOpen && regularStoreClose === actualStoreClose, but for
 * days that we might set Special Store Hours (use case: holidays), the logistics
 * delivery hours reflect the actual store hours.
 */

export type StoreHoursType = {
  regularStoreOpen: Date | undefined
  regularStoreClose: Date | undefined
  actualStoreOpen: Date | undefined
  actualStoreClose: Date | undefined
}
export interface ShiftManagementContextValue {
  storeHours: StoreHoursType
  setStoreHours?(value: React.SetStateAction<StoreHoursType>): void
}

export const ShiftManagementContext = React.createContext<ShiftManagementContextValue>({
  storeHours: {
    regularStoreOpen: undefined,
    regularStoreClose: undefined,
    actualStoreOpen: undefined,
    actualStoreClose: undefined,
  },
  setStoreHours: null,
})

export const ShiftsStateContextProvider: FunctionComponent<{}> = ({ children }) => {
  const [storeHours, setStoreHours] = useState<StoreHoursType>({
    regularStoreOpen: undefined,
    regularStoreClose: undefined,
    actualStoreOpen: undefined,
    actualStoreClose: undefined,
  })
  return (
    <ShiftManagementContext.Provider value={{ storeHours, setStoreHours }}>
      {children}
    </ShiftManagementContext.Provider>
  )
}

export const useShiftManagementContext = () => useContext(ShiftManagementContext)
